import { xBaseTheme } from "@eisinc/XDL/types";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

const borderSize = "2px";
const disabledAlpha = 0.5;
const size = "18px";
const left = 26;

export default {
    defaultProps: {
        css: css`
            input {
                opacity: 0;

                + label {
                    margin-right: ${left * 2}px;
                    margin-left: 5px;
                }
                &:checked:not(:disabled) + label::before {
                    background: transparent;
                    border: ${borderSize} solid ${getColor("common.ui1")};
                }
                & + label::before {
                    content: "";
                    position: absolute;
                    left: -${left}px;
                    top: 0;
                    height: ${size};
                    width: ${size};
                    border: ${borderSize} solid ${getColor("common.ui1")};
                    border-radius: 100%;
                    background: transparent;
                }
                &:checked + label::after,
                &:checked:focus + label::after,
                &:focus:not(:disabled) + label::after {
                    content: "";
                    display: block;
                    height: 8px;
                    width: 8px;
                    border-radius: 100%;
                    background: ${getColor("primary")};
                    position: absolute;
                    left: -21px;
                    top: 5px;
                }
                &:focus:not(:disabled) + label::before {
                    box-shadow: 0 0 0 2px ${getColor("warning.main")};
                }
                &:disabled + label,
                &:focus:disabled + label {
                    cursor: not-allowed;
                    opacity: 0.5;
                }

                &:hover:not(:disabled) + label {
                    cursor: pointer;
                }
            }
        `,
    },
    groupDefaultProps: {},
} as xBaseTheme["radio"];
